import axios from "axios";
import { adalApiFetch } from "../adalConfig";

// AI service runs separately from Licensing.Admin.Api.
// Default port matches Licensing.AI.Api Kestrel default; override below for non-local envs.
//http://localhost:5050/


export const POST_AI_ASK       =  "https://epradmin-stg.nvidia.com/api/ai/ask";
export const POST_AI_ANALYTICS =  "https://epradmin-stg.nvidia.com/api/ai/analytics";



export async function askAi(question, history) {
  const response = await adalApiFetch(axios, POST_AI_ASK, {
    method: "post",
    data: { question, history: history || [] },
  });
  return response.data; // { answer, toolResults: [{ tool, args, result }, ...] }
}

// Direct aggregate query — bypasses the LLM. Cheap, deterministic, used by the
// Analytics tab charts. Pass any subset of {startDate, endDate, hoursBack,
// licenseType, productFamily, country, status, groupBy}.
export async function fetchAnalytics(params) {
  const response = await adalApiFetch(axios, POST_AI_ANALYTICS, {
    method: "post",
    data: params || {},
  });
  return response.data; // { startDate, endDate, groupBy, total, breakdown: [{ groupKey, count }] }
}
